// Format the sandbox phone for display so it reads like a real contact, not
// a concatenated string. Two env-var shapes are recognised:
//
//   - 12 digits, leading '972' (IL mobile)  → '+972 55 704 6276'
//   - 11 digits, leading '1'   (NANP/US)    → '+1 737-237-0900'
//
// Anything else returns `+${raw}` unchanged (safe fallback for the empty-env
// case or future dial codes).
//
// Phase 127: extracted from sandbox.tsx:130-133 so both /w/:ws/sandbox and
// /w/:ws/sandbox/quick-start consume the same helper.
// Phase 125-followup: NANP arm added when prod sandbox flipped to a separate
// US WABA (+1 737-237-0900) — staging stays on +972.
//
// IMPORTANT: designed ONLY for raw env-var digits (NO leading +). Do NOT
// pass already-'+'-prefixed session.phone strings through this helper —
// the output will double-prefix ('++1555…'). For bound-session phones,
// render `session.phone` directly (matches sandbox.tsx:551's precedent).
export function formatSandboxPhone(raw: string): string {
  if (raw.length === 12 && raw.startsWith('972')) {
    return `+${raw.slice(0, 3)} ${raw.slice(3, 5)} ${raw.slice(5, 8)} ${raw.slice(8)}`;
  }
  if (raw.length === 11 && raw.startsWith('1')) {
    return `+${raw.slice(0, 1)} ${raw.slice(1, 4)}-${raw.slice(4, 7)}-${raw.slice(7)}`;
  }
  return `+${raw}`;
}
